import {RequestInfo} from "@repo/shared-core";

export const actualMinutes = Intl.NumberFormat(RequestInfo.kaLocale).format(
    58.7,
);
export const approxMinutes = Intl.NumberFormat(RequestInfo.kaLocale).format(58);
export const actualYears = Intl.NumberFormat(RequestInfo.kaLocale).format(
    110171,
);
